import { Component, ChangeDetectionStrategy } from '@angular/core';
import { WorkService } from '../services';

@Component({
  selector: 'app-omni-channel',
  template: `
    <iframe
      *ngIf="workSvc.omniChannel$ | async"
      class="h-100 w-100"
      src="https://inbox.messagebird.com/"
      style="border: 0"
    ></iframe>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        overflow: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OmniChannelComponent {
  constructor(public workSvc: WorkService) {
    workSvc.omniChannel = true;
  }
}
